// extracted by mini-css-extract-plugin
export var levels = "style-module--levels--486c9";
export var levels__description = "style-module--levels__description--0c912";
export var levels__item = "style-module--levels__item--ba86c";
export var levels__list = "style-module--levels__list--109fa";
export var levels__title = "style-module--levels__title--b1e08";